import React from 'react';
import ListItemArvore from './ListItemArvore';

const ListaArvoreLinhas = ({ linha }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = (value) => setOpen(open === value ? false : value);
  return (
    // <ListButtonMenu>
    <>
      {linha &&
        linha.map(({ nome, maquinario }, index) => (
          <ListItemArvore
            title={nome}
            array={maquinario}
            key={index}
            open={open}
            handleOpen={handleOpen}
            index={index}
          />
        ))}
    </>
    // </ListButtonMenu>
  );
};

export default ListaArvoreLinhas;
